import { Drawing } from "./drawings/Drawing";
import { Nudge, Translate } from "./Geometry";
import { Point } from "./Point";
import { Rectangle } from "./Rectangle";
import { exists } from "./utils";
import { Style, Icon, GeomPoint, Feature } from './openlayers/ol-bridge';

export abstract class MapFeature {
    protected abstract get raw_coords(): Point | null;
    protected abstract get raw_geo_ref(): Rectangle | null;
    public abstract get as_json(): any;
    public abstract get generic_id(): string;
    public abstract get icon_url(): string;
    public abstract get map_feature_type(): string;
    public abstract get raw(): any;

    private _adj_cluster_coords: Point;
    private _adj_coords: Point;
    private _adj_geo_ref: Rectangle;
    public get adj_cluster_coords(): Point {
        if (!exists(this._adj_cluster_coords)) {
            return this.adj_coords;
        }
        return this._adj_cluster_coords;
    }

    public get adj_coords(): Point {
        if (!exists(this._adj_coords)) {
            return this.raw_coords;
        }
        return this._adj_coords;
    }

    public get adj_geo_ref(): Rectangle {
        if (!exists(this._adj_geo_ref)) {
            return this.raw_geo_ref;
        }
        return this._adj_geo_ref;
    }

    public get is_delustered(): boolean {
        return exists(this._adj_cluster_coords);
    }

    public translate(drawing: Drawing) {
        let adj_coords: Point = drawing.p0;
        if (exists(this.raw_coords)) {
            // if this feature has no coords, set the adj coord to the provided p0
            adj_coords = Translate(this.raw_coords, this.raw_geo_ref, drawing.geo_ref);
        }
        // console.log(adj_coords, drawing.geo_ref, this.raw);
        this._adj_coords = adj_coords;
        this._adj_geo_ref = drawing.geo_ref;
        this._adj_cluster_coords = null;
        return;
    }

    public nudge_apart(rhs: MapFeature, minimum_distance: number, nudge_max: number) {
        let start_rhs = rhs.adj_cluster_coords;
        let start_lhs = this.adj_cluster_coords;
        this._adj_cluster_coords = Nudge(start_lhs, start_rhs, minimum_distance, nudge_max);
        rhs._adj_cluster_coords = Nudge(start_rhs, start_lhs, minimum_distance, nudge_max);
    }

    public is_valid(): boolean {
        if (exists(this.raw_coords)) {
            if (exists(this.raw_geo_ref)) {
                if (this.icon_url !== "") {
                    return true;
                }
            }
        }
        return false;
    }

    public createOpenlayersFeature(p0: Point): any {
        const iconStyle = [
            new Style(
                {
                    image: new Icon(({
                        anchor: [.5, .5],
                        anchorXUnits: "fraction",
                        anchorYUnits: "fraction",
                        src: this.icon_url,
                    })),
                })
        ];

        let coords: Point = this.adj_cluster_coords;
        if (!exists(coords)) {
            coords = p0;
        }

        let point = new GeomPoint([coords.X, coords.Y], "XY");
        let feature = new Feature({
            geometry: point,
        });

        feature.setId(this.generic_id);
        feature.setStyle(iconStyle);
        feature.data = this.as_json;
        feature.data.feature = this.map_feature_type;
        feature.raw = this.raw;

        return feature;
    }
}
